import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Settings } from "@hermes/core-app-core";

@Injectable()
export class ResetPasswordService {
    private http = inject(HttpClient);
    private settings = inject(Settings);

    public verify(hash: string): Observable<void> {
        return this.http.get<void>(
            `${this.settings.apiUrl}/customer/password/reset/check`,
            {
                params: new HttpParams().set("hash", hash),
            },
        );
    }

    public reset(hash: string, password: string): Observable<void> {
        return this.http.put<void>(
            `${this.settings.apiUrl}/customer/password/reset`,
            {
                hash,
                password,
            },
        );
    }
}
